import React, { useState, useEffect } from 'react';
import {
  Container,
  Form,
  Button,
  ToggleButton,
  ToggleButtonGroup,
} from 'react-bootstrap';
import FormInput from '../../common/FormInput';
import FormLabel from '../../common/FormLabel';
import { HiOutlineChevronLeft } from '@react-icons/all-files/hi/HiOutlineChevronLeft';
import { useHistory, useParams } from 'react-router-dom';
import { addTreehouseChallenge } from '../../../constants/error.constants';
import { useForm } from 'react-hook-form';
import { SCHOOL_CHALLENGES } from '../../../constants/routes.constants';
import PartnerHeader from './PartnerHeader';
import { ErrorMessage } from '@hookform/error-message';
import { schoolViewModel } from './school.view.model';
import { useAuth } from '../../auth/Auth';
import PartnerUnverifiedModal from './PartnerUnverifiedModal';
import { nextChallengeViewModel } from '../next_challenge/next.challenge.viewmodel';
import { customStyles } from '../../../utils/utils';
import Select from 'react-select';
import UploadSection from './media_upload/UploadSection';
import LoadButton from '../../common/LoadButton';

const CampEditChallenge = () => {
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(false);
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [youtubeUrl, setYoutubeUrl] = useState('');
  const [videoUrl, setVideoUrl] = useState('');
  const [youtubeErrors, setYoutubeErrors] = useState(false);
  const [challengeScope, setChallengeScope] = useState('private');
  const [image, setImage] = useState();
  const [isDisable, setIsDisable] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [imageName, setImageName] = useState('');
  const [showImageError, setShowImageError] = useState(false);
  const { fetchAPI } = useAuth();
  const { cid } = useParams();
  const [challengeDetails, setChallengeDetails] = useState();
  const [selectedTag, setSelectedTag] = useState([]);
  const [branchOptions, setBranchOptions] = useState([]);
  const [uploadType, setUploadType] = useState('picture');
  const [video, setVideo] = useState(null);
  const [picturePreview, setPicturePreview] = useState(null);
  const [videoPreview, setVideoPreview] = useState(null);
  const [imageError, setImageError] = useState('');
  const [videoError, setVideoError] = useState('');
  const { register, watch, handleSubmit, setError, errors, getValues } =
    useForm({
      mode: 'onBlur',
    });

  const pageRedirect = () => {
    history.goBack();
  };

  const handleBranchAdd = (selectedValue) => {
    setSelectedTag(selectedValue);
  };

  const getChallengeDetail = () => {
    fetchAPI(nextChallengeViewModel.getChallengeDetails, cid)
      .then((res) => {
        setChallengeDetails(res);
        setTitle(res.title);
        setDescription(res.description);
        setYoutubeUrl(res.youtube_url);
        setVideoUrl(res.video_url);
        setVideoPreview(res.video_url);
        setImageName(res.picture_url);
        setPicturePreview(res.picture_url);
        setChallengeScope(res?.challenge_scope);
        res.tag_list.map((tag) => {
          setSelectedTag((selectedTag) => [
            ...selectedTag,
            { value: tag.id, label: tag.tag },
          ]);
        });
      })
      .catch((error) => console.log(error));
  };

  const onSubmit = handleSubmit(() => {
    let isValid = true;

    // Check for image validation if the uploadType is 'picture'
    if (uploadType === 'picture' && !image && !challengeDetails?.picture_url) {
      setImageError('Please select an image.');
      isValid = false;
    } else {
      setImageError('');
    }

    // Check for video or youtube URL validation if the uploadType is 'video'
    if (
      uploadType === 'video' &&
      !video &&
      !youtubeUrl &&
      !challengeDetails?.video_url
    ) {
      setVideoError('Please select a video or enter a YouTube URL.');
      isValid = false;
    } else {
      setVideoError('');
    }

    if (!isValid) return; // Prevent further submission if validation fails
    setIsDisable(true);
    setIsLoading(true);
    let tags = [];
    selectedTag.map((tag) => {
      tags.push(tag.value);
    });
    let data = {
      title: title,
      description: description,
      deadline: 7,
      tags: tags,
      youtube_url: youtubeUrl ? youtubeUrl : null,
    };
    if (uploadType === 'picture') {
      data.video_url = null;
    } else {
      data.picture_url = null;
      if (!video) {
        data.video_url = null; // if no video is selected
      }
    }

    schoolViewModel
      .editChallenge(cid, data)
      .then((res) => {
        handleMediaUpload();
      })
      .catch((err) => {
        console.log(err);
        setIsDisable(true);
      });
  });

  const handleMediaUpload = () => {
    if (uploadType === 'picture') {
      if (image) {
        schoolViewModel
          .addChallengeMedia(cid, image)
          .then((res) => {
            handleRedirect();
          })
          .catch((err) => console.log(err));
      } else {
        handleRedirect();
      }
    }
    if (uploadType === 'video') {
      if (video) {
        schoolViewModel
          .addChallengeVideo(cid, video)
          .then((res) => {
            handleRedirect();
          })
          .catch((err) => console.log(err));
      } else {
        schoolViewModel
          .deleteChallengeVideo(cid)
          .then((res) => {})
          .catch((err) => console.log(err));
        handleRedirect();
      }
    } else {
      schoolViewModel
        .deleteChallengeVideo(cid)
        .then((res) => {})
        .catch((err) => console.log(err));
    }
  };

  const handleRedirect = () => {
    setIsDisable(false);
    setIsLoading(false);
    history.push(SCHOOL_CHALLENGES);
  };

  const getInterestBranches = () => {
    fetchAPI(nextChallengeViewModel.getTags, { limit: 99 })
      .then((res) => {
        res.map((tag) => {
          setBranchOptions((branchOptions) => [
            ...branchOptions,
            { value: tag.id, label: tag.tag, name: tag.tag },
          ]);
        });
      })
      .catch((err) => {});
  };

  const handleScopeChange = (val) => {
    setChallengeScope(val);
  };

  useEffect(() => {
    getChallengeDetail();
    getInterestBranches();
  }, []);

  const handleYoutube = (e) => {
    setYoutubeUrl(e.target.value);
    if (e.target.value === '') {
      setYoutubeErrors(false);
      setIsDisable(false);
    } else {
      var regExp =
        /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=|\?v=)([^#\&\?]*).*/;
      var match = e.target.value.match(regExp);
      if (match && match[2].length == 11) {
        setYoutubeErrors(false);
        setIsDisable(false);
      } else {
        setIsDisable(true);
        setYoutubeErrors('Please enter a valid url');
      }
    }
    setVideoError(null);
  };

  return challengeDetails ? (
    <div className="partner-wrapper-main">
      <PartnerHeader />
      <PartnerUnverifiedModal
        showModal={showModal}
        setShowModal={setShowModal}
      />
      <div className="add-more-branches partner_add_challenges">
        <span className="back-btn" onClick={pageRedirect}>
          <HiOutlineChevronLeft />
        </span>
        <Container>
          <div className="d-flex justify-content-center">
            <div>
              <h2 className="mb-50">
                Edit challenge for "<span>{challengeDetails.title}</span>"
              </h2>
              <Form className="mb-40" onSubmit={onSubmit}>
                <Form.Group className="mb-3" controlId="">
                  <FormLabel>Title</FormLabel>
                  <FormInput
                    name="title"
                    className="form-input"
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                  />
                  <ErrorMessage
                    errors={errors}
                    name="title"
                    className="small text-danger"
                    as="label"
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Description</Form.Label>
                  <Form.Control
                    name="description"
                    as="textarea"
                    rows="3"
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                  />
                  <ErrorMessage
                    errors={errors}
                    name="description"
                    className="small text-danger"
                    as="label"
                  />
                </Form.Group>
                <ToggleButtonGroup
                  className="radio_styles"
                  type="radio"
                  name="challenge_scope"
                  defaultValue="private"
                  value={challengeScope}
                  onChange={handleScopeChange}
                >
                  <ToggleButton
                    disabled={
                      challengeDetails?.created_by?.user_type === 'school'
                    }
                    id="tbg-radio-1"
                    value="private"
                    className={challengeScope === 'private' && 'gred-btn'}
                  >
                    Tribe only
                  </ToggleButton>
                  <ToggleButton
                    id="tbg-radio-2"
                    value="public"
                    className={challengeScope === 'public' && 'gred-btn'}
                  >
                    Entire Camp
                  </ToggleButton>
                </ToggleButtonGroup>
                <Form.Group className="mb-3" controlId="">
                  <Form.Label>Select interest branches</Form.Label>
                  <Select
                    name="hash_tag"
                    options={branchOptions}
                    isMulti
                    styles={customStyles}
                    required
                    value={selectedTag}
                    theme={(theme) => ({
                      ...theme,
                      borderRadius: '6px',
                      colors: {
                        ...theme.colors,
                        primary: '#80e4e1',
                      },
                    })}
                    onChange={handleBranchAdd}
                    inputRef={register({
                      required: addTreehouseChallenge.hast_tag.required,
                    })}
                  />
                  <ErrorMessage
                    errors={errors}
                    name="hash_tag"
                    className="small text-danger"
                    as="label"
                  />
                </Form.Group>
                <UploadSection
                  uploadType={uploadType}
                  setUploadType={setUploadType}
                  setImageName={setImageName}
                  setImage={setImage}
                  setShowImageError={setShowImageError}
                  video={video}
                  setVideo={setVideo}
                  handleYoutube={handleYoutube}
                  setYoutubeUrl={setYoutubeUrl}
                  picturePreview={picturePreview}
                  setPicturePreview={setPicturePreview}
                  videoPreview={videoPreview}
                  setVideoPreview={setVideoPreview}
                  youtubeUrl={youtubeUrl}
                  setImageError={setImageError}
                  setNoVideoError={setVideoError}
                />
                {imageError && <div className="text-danger">{imageError}</div>}
                {videoError && <div className="text-danger">{videoError}</div>}
                {youtubeErrors && (
                  <div className="text-danger">{youtubeErrors}</div>
                )}
                <LoadButton
                  type="submit"
                  text="Save Changes"
                  className="common-round-btn submit-btn mt-5 w-100 gred-btn"
                  isDisabled={isDisable}
                  isLoading={isLoading}
                />
              </Form>
            </div>
          </div>
        </Container>
      </div>
    </div>
  ) : (
    ''
  );
};
export default CampEditChallenge;
